import axios from '@/libs/api.request'

const Api = {
  DeviceList: '/member/devices',
  DeviceOrder: '/device/order',
  DeviceCommand: '/device/command',
  DeviceBind: '/device/bind',
  DeviceWifi: '/device/wifi',
  DeviceTradePay: '/device/trade/pay'
}

export const getDevices = (data) => {
  return axios.request({
    url: Api.DeviceList,
    data: data,
    method: 'post'
  })
}

export const addDeviceOrder = (data) => {
  return axios.request({
    url: Api.DeviceOrder,
    data: data,
    method: 'post'
  })
}

export const getDeviceTradePay = (data) => {
  return axios.request({
    url: Api.DeviceTradePay,
    data: data,
    method: 'post'
  })
}

export const sendDeviceCommand = (data) => {
  return axios.request({
    url: Api.DeviceCommand,
    data: data,
    method: 'post'
  })
}

export const bindDevice = (data) => {
  return axios.request({
    url: Api.DeviceBind,
    data: data,
    method: 'put'
  })
}

export const setDeviceWifi = (data) => {
  return axios.request({
    url: Api.DeviceWifi,
    data: data,
    method: 'put'
  })
}



// WEBPACK FOOTER //
// ./src/api/device.js